import { TAO6Dataset } from "./types";


export const TAO6_SAMPLE_DATASETS: TAO6Dataset[] = [
  {
    id: 'coco-custom-detection',
    name: 'COCO Custom Detection',
    format: 'coco',
    task: 'object_detection',
    trainCount: 8000,
    valCount: 2000,
    testCount: 1000,
    classes: ['person', 'car', 'truck', 'bicycle', 'motorcycle', 'bus', 'traffic_light', 'stop_sign', 'parking_meter', 'bench'],
    classCount: 10,
    totalSize: '4.2 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 7,
    path: '/workspace/datasets/coco_custom',
  },
  {
    id: 'kitti-vehicles',
    name: 'KITTI Vehicle Detection',
    format: 'kitti',
    task: 'object_detection',
    trainCount: 7481,
    valCount: 2000,
    classes: ['Car', 'Van', 'Truck', 'Pedestrian', 'Cyclist', 'Tram', 'Person_sitting', 'Misc'],
    classCount: 8,
    totalSize: '12.5 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 14,
    path: '/workspace/datasets/kitti_vehicles',
  },
  {
    id: 'product-classification',
    name: 'Product Classification',
    format: 'directory',
    task: 'image_classification',
    trainCount: 5000,
    valCount: 1000,
    testCount: 500,
    classes: ['electronics', 'clothing', 'furniture', 'food', 'toys', 'books', 'sports', 'beauty', 'automotive', 'garden', 'office', 'pets', 'jewelry', 'health', 'baby', 'shoes', 'bags', 'watches', 'tools', 'home'],
    classCount: 20,
    totalSize: '2.8 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 5,
    path: '/workspace/datasets/product_classification',
  },
  {
    id: 'imagenet-subset',
    name: 'ImageNet Subset',
    format: 'directory',
    task: 'image_classification',
    trainCount: 10000,
    valCount: 2000,
    classes: ['cat', 'dog', 'bird', 'fish', 'horse', 'elephant', 'bear', 'zebra', 'giraffe', 'monkey'],
    classCount: 10,
    totalSize: '5.1 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 10,
    path: '/workspace/datasets/imagenet_subset',
  },
  {
    id: 'retail-detection',
    name: 'Retail Shelf Detection',
    format: 'coco',
    task: 'object_detection',
    trainCount: 3500,
    valCount: 750,
    testCount: 250,
    classes: ['product', 'shelf', 'price_tag', 'empty_space', 'promotion_sign'],
    classCount: 5,
    totalSize: '1.8 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 3,
    path: '/workspace/datasets/retail_shelf',
  },

  // =============================================
  // INSTANCE SEGMENTATION DATASETS
  // =============================================
  {
    id: 'coco-instance-seg',
    name: 'COCO Instance Segmentation',
    format: 'coco',
    task: 'instance_segmentation',
    trainCount: 118287,
    valCount: 5000,
    classes: ['person', 'car', 'chair', 'book', 'bottle', 'cup', 'dining table', 'potted plant', 'couch', 'bed'],
    classCount: 10,
    totalSize: '18.5 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 20,
    path: '/workspace/datasets/coco_instance',
  },
  {
    id: 'medical-cell-seg',
    name: 'Medical Cell Segmentation',
    format: 'coco',
    task: 'instance_segmentation',
    trainCount: 4500,
    valCount: 1000,
    testCount: 500,
    classes: ['cell_nucleus', 'cell_membrane', 'mitochondria', 'cytoplasm'],
    classCount: 4,
    totalSize: '3.2 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 8,
    path: '/workspace/datasets/medical_cell_seg',
  },

  // =============================================
  // SEMANTIC SEGMENTATION DATASETS
  // =============================================
  {
    id: 'cityscapes-seg',
    name: 'Cityscapes Segmentation',
    format: 'coco',
    task: 'semantic_segmentation',
    trainCount: 2975,
    valCount: 500,
    testCount: 1525,
    classes: ['road', 'sidewalk', 'building', 'wall', 'fence', 'pole', 'traffic_light', 'traffic_sign', 'vegetation', 'terrain', 'sky', 'person', 'rider', 'car', 'truck', 'bus', 'train', 'motorcycle', 'bicycle'],
    classCount: 19,
    totalSize: '11.8 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 25,
    path: '/workspace/datasets/cityscapes',
  },
  {
    id: 'ade20k-indoor',
    name: 'ADE20K Indoor Scenes',
    format: 'coco',
    task: 'semantic_segmentation',
    trainCount: 20210,
    valCount: 2000,
    classes: ['wall', 'floor', 'ceiling', 'window', 'door', 'table', 'chair', 'sofa', 'bed', 'cabinet', 'lamp', 'curtain', 'pillow', 'mirror', 'television'],
    classCount: 15,
    totalSize: '4.7 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 12,
    path: '/workspace/datasets/ade20k_indoor',
  },
  {
    id: 'satellite-land-seg',
    name: 'Satellite Land Cover',
    format: 'directory',
    task: 'semantic_segmentation',
    trainCount: 8000,
    valCount: 2000,
    testCount: 1000,
    classes: ['water', 'forest', 'urban', 'agriculture', 'barren', 'grassland', 'wetland'],
    classCount: 7,
    totalSize: '6.3 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 15,
    path: '/workspace/datasets/satellite_landcover',
  },

  // =============================================
  // POSE ESTIMATION DATASETS
  // =============================================
  {
    id: 'coco-keypoints',
    name: 'COCO Keypoints',
    format: 'coco',
    task: 'pose_estimation',
    trainCount: 57000,
    valCount: 5000,
    classes: ['nose', 'left_eye', 'right_eye', 'left_ear', 'right_ear', 'left_shoulder', 'right_shoulder', 'left_elbow', 'right_elbow', 'left_wrist', 'right_wrist', 'left_hip', 'right_hip', 'left_knee', 'right_knee', 'left_ankle', 'right_ankle'],
    classCount: 17,
    totalSize: '8.9 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 30,
    path: '/workspace/datasets/coco_keypoints',
  },
  {
    id: 'fitness-pose',
    name: 'Fitness Exercise Poses',
    format: 'coco',
    task: 'pose_estimation',
    trainCount: 12000,
    valCount: 3000,
    testCount: 1500,
    classes: ['nose', 'left_eye', 'right_eye', 'left_ear', 'right_ear', 'left_shoulder', 'right_shoulder', 'left_elbow', 'right_elbow', 'left_wrist', 'right_wrist', 'left_hip', 'right_hip', 'left_knee', 'right_knee', 'left_ankle', 'right_ankle'],
    classCount: 17,
    totalSize: '4.2 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 6,
    path: '/workspace/datasets/fitness_pose',
  },

  // =============================================
  // ACTION RECOGNITION DATASETS
  // =============================================
  {
    id: 'kinetics-subset',
    name: 'Kinetics-400 Subset',
    format: 'directory',
    task: 'action_recognition',
    trainCount: 24000,
    valCount: 4000,
    testCount: 2000,
    classes: ['walking', 'running', 'jumping', 'sitting', 'standing', 'waving', 'clapping', 'dancing', 'swimming', 'cycling', 'driving', 'cooking', 'eating', 'drinking', 'reading', 'writing', 'typing', 'phone_call', 'hugging', 'handshake'],
    classCount: 20,
    totalSize: '45.6 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 45,
    path: '/workspace/datasets/kinetics_subset',
  },
  {
    id: 'surveillance-actions',
    name: 'Surveillance Actions',
    format: 'directory',
    task: 'action_recognition',
    trainCount: 8000,
    valCount: 2000,
    testCount: 1000,
    classes: ['walking', 'running', 'falling', 'fighting', 'loitering', 'vandalism', 'theft', 'normal'],
    classCount: 8,
    totalSize: '22.3 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 18,
    path: '/workspace/datasets/surveillance_actions',
  },
  {
    id: 'sports-actions',
    name: 'Sports Activity Recognition',
    format: 'directory',
    task: 'action_recognition',
    trainCount: 15000,
    valCount: 3000,
    classes: ['basketball_shot', 'soccer_kick', 'tennis_serve', 'golf_swing', 'baseball_pitch', 'volleyball_spike', 'swimming_stroke', 'running_sprint', 'high_jump', 'diving'],
    classCount: 10,
    totalSize: '38.2 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 22,
    path: '/workspace/datasets/sports_actions',
  },

  // =============================================
  // OCR DATASETS
  // =============================================
  {
    id: 'scene-text-detection',
    name: 'Scene Text Detection',
    format: 'coco',
    task: 'ocr',
    trainCount: 10000,
    valCount: 2000,
    testCount: 1000,
    classes: ['text_region'],
    classCount: 1,
    totalSize: '5.8 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 16,
    path: '/workspace/datasets/scene_text_det',
  },
  {
    id: 'license-plate-ocr',
    name: 'License Plate OCR',
    format: 'directory',
    task: 'ocr',
    trainCount: 25000,
    valCount: 5000,
    testCount: 2500,
    classes: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    classCount: 36,
    totalSize: '2.1 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 9,
    path: '/workspace/datasets/license_plate_ocr',
  },
  {
    id: 'document-ocr',
    name: 'Document Text Recognition',
    format: 'directory',
    task: 'ocr',
    trainCount: 50000,
    valCount: 10000,
    testCount: 5000,
    classes: ['printed_text', 'handwritten_text', 'table', 'figure', 'formula'],
    classCount: 5,
    totalSize: '8.4 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 11,
    path: '/workspace/datasets/document_ocr',
  },
  {
    id: 'receipt-ocr',
    name: 'Receipt & Invoice OCR',
    format: 'coco',
    task: 'ocr',
    trainCount: 18000,
    valCount: 4000,
    testCount: 2000,
    classes: ['merchant_name', 'date', 'total', 'subtotal', 'tax', 'item_name', 'item_price', 'quantity', 'payment_method', 'address'],
    classCount: 10,
    totalSize: '3.6 GB',
    status: 'ready',
    createdAt: Date.now() - 86400000 * 4,
    path: '/workspace/datasets/receipt_ocr',
  },
];

